import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Create from "./Create";

export default class AddAttachment extends Component {
  static propTypes = {
    attachmentTypes: PropTypes.instanceOf(Object),
    referenceOptions: PropTypes.arrayOf(PropTypes.shape({})),
    resourceId: PropTypes.number.isRequired,
    resourceType: PropTypes.string.isRequired,
    multiple: PropTypes.bool
  };

  state = {
    open: false,
    type: "attachment",
    dropdownOpen: false
  };

  close = () => this.setState({ open: false });

  toggleDropdown = () =>
    this.setState(state => ({
      dropdownOpen: !state.dropdownOpen
    }));

  close = () => this.setState({ open: false });

  updateType = type => () =>
    this.setState({ type, open: true, dropdownOpen: false });

  render() {
    const { multiple, resourceId, attachmentTypes, resourceType } = this.props;
    const { type, open, dropdownOpen } = this.state;
    const classes = classNames("btn-group pull-right dropdown", {
      open: dropdownOpen
    });

    return (
      <div className={classes}>
        <button
          onClick={this.updateType("attachment")}
          className="btn btn-primary btn-hollow"
        >
          <i className="fa fa-fw fa-plus" />
          Add
          <Create
            resourceId={resourceId}
            resourceType={resourceType}
            type={type}
            open={open}
            close={this.close}
            multiple={multiple}
            attachmentTypes={attachmentTypes}
            referenceOptions={this.props.referenceOptions}
          />
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/AddAttachment.jsx